<template>
  <div
    class="
      py-4
      sm:py-7
    "
  >
    <hr class="bg-gray-500" />
  </div>
</template>

<gql component>

</gql>
